import { ActionButtonVariants } from 'components/action-button';

export const config = {
  buttonVariant: ActionButtonVariants.PRIMARY,
  hasBorder: true,
  hasBoxShadow: false,
};
